import { render } from "./AccountExports.vue?vue&type=template&id=6a851a0c&scoped=true"
import script from "./AccountExports.vue?vue&type=script&lang=js"
export * from "./AccountExports.vue?vue&type=script&lang=js"

import "./AccountExports.vue?vue&type=style&index=0&id=6a851a0c&scoped=true&lang=scss"

import exportComponent from "/builds/swift-dental/my-swift-dental/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a851a0c"]])

export default __exports__